import { MDBBtn, MDBIcon, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { getAllUserInfo } from "../../Store/UserAction";
import { api } from "../../utils/axios";

function AddTeamMember({ show, setShow }) {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const [loading, setLoading] = useState(false);
	const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
	const [subscriptionError, setSubscriptionError] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleSubmit = async () => {
		if (!formData.email || !formData.password) {
			toast.error("لطفاً تمام فیلدها را تکمیل کنید.");
			return;
		}

		setLoading(true);
		setSubscriptionError(null);

		try {
			const response = await api.post("/leader/add_user", formData, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			});

			if (response.status === 200 || response.status === 201) {
				// Success message for both 200 and 201 statuses
				toast.success("کاربر جدید با موفقیت اضافه شد!");

				// Trigger Redux action to refresh user data
				dispatch(getAllUserInfo());

				// Close modal and redirect
				if (setShow) {
					setShow(false);
				} else {
					navigate("/home");
				}
			} else {
				toast.error("خطایی رخ داده است. لطفاً دوباره تلاش کنید.");
			}
		} catch (error) {
			if (error.response) {
				// Handle 403 error (subscription limit reached)
				if (error.response.status === 403) {
					setSubscriptionError(error.response.data);
					setShowSubscriptionModal(true);
				} else {
					toast.error(error.response.data?.error || "خطا در ارتباط با سرور.");
				}
			} else {
				toast.error("خطا در ارتباط با سرور.");
			}
		} finally {
			setLoading(false);
		}
	};

	const handleCloseModal = () => {
		if (setShow) {
			setShow(false);
		} else {
			navigate("/home");
		}
	};

	const handleUpgradeSubscription = () => {
		// Navigate to subscription page or open subscription modal
		navigate("/userProfile");
		handleCloseModal();
	};

	return (
		<>
			<div className="add-team-member-content">
				<h2 className="add-team-member-title">اضافه کردن عضو تیم</h2>

				<div className="add-team-member-form">
					{/* Email */}
					<div className="form-group">
						<label className="form-label">ایمیل:</label>
						<input
							type="email"
							className="form-input"
							value={formData.email}
							onChange={(e) =>
								setFormData({ ...formData, email: e.target.value })
							}
							placeholder="ایمیل کاربر را وارد کنید"
						/>
					</div>

					{/* Password */}
					<div className="form-group">
						<label className="form-label">رمز عبور:</label>
						<input
							type="password"
							className="form-input"
							value={formData.password}
							onChange={(e) =>
								setFormData({ ...formData, password: e.target.value })
							}
							placeholder="رمز عبور کاربر را وارد کنید"
						/>
					</div>

					{/* Submit Button */}
					<button
						className="submit-btn"
						onClick={handleSubmit}
						disabled={loading}
					>
						{loading ? (
							<>
								<MDBSpinner size="sm" role="status" />
								<span>در حال پردازش...</span>
							</>
						) : (
							<>
								<MDBIcon fas icon="user-plus" className="submit-btn-icon" />
								اضافه کردن عضو
							</>
						)}
					</button>
				</div>
			</div>

			{/* Subscription Limit Modal */}
			{showSubscriptionModal && subscriptionError && (
				<div className="subscription-limit-modal-overlay">
					<div className="subscription-limit-modal">
						<div className="subscription-limit-header">
							<MDBIcon
								fas
								icon="exclamation-triangle"
								className="warning-icon"
							/>
							<h3>محدودیت اشتراک</h3>
						</div>

						<div className="subscription-limit-content">
							<p className="subscription-limit-message">
								{subscriptionError.error}
							</p>

							<div className="subscription-limit-details">
								<div className="subscription-detail">
									<span className="detail-label">پلن فعلی:</span>
									<span className="detail-value">
										{subscriptionError.current_plan}
									</span>
								</div>
								<div className="subscription-detail">
									<span className="detail-label">حد مجاز اعضا:</span>
									<span className="detail-value">
										{subscriptionError.allowed_members} نفر
									</span>
								</div>
							</div>
						</div>

						<div className="subscription-limit-actions">
							<button
								className="upgrade-btn"
								onClick={handleUpgradeSubscription}
							>
								ارتقای اشتراک
							</button>
							<button
								className="cancel-btn"
								onClick={() => setShowSubscriptionModal(false)}
							>
								انصراف
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default AddTeamMember;
